export default __webpack_public_path__ + "static/media/ic-instruction-01.f23bcb7f.svg";